// Ce fichier est généré automatiquement par le devtool
// Ne pas modifier manuellement

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const TestSpritesheets: ISpritesheetMetadata[] = [];
